/**
* @Description 文件功能说明：修改密码弹窗
* @Author cc
* @Time 2021/04/01
**/

/* HTML */
<template>
    <el-dialog :title="dialogForm.title"
               :visible.sync="dialogForm.dialogFormVisible"
               :close-on-click-modal="false"
               custom-class="form-dialog"
               v-dialogDrag
               class="dialog_title"
               @close="handleDialogClose"
    >

        <el-form :model="dialogRowForm" :rules="rules" ref="dialogRowForm" label-width="120px">
            <el-form-item label="登录用户：" prop="userName" style="margin-bottom: 10px;">
                <div v-if="dialogForm.isEdit" style="line-height: 40px;padding-left: 10px;">
                    {{dialogRowForm.userName}}
                </div>
                <div v-else>
                    <el-input v-model="dialogRowForm.userName" auto-complete="off" autocomplete="false" clearable/>
                </div>
            </el-form-item>
            <el-form-item label="旧密码：" prop="oldPasword">
                <el-input v-model="dialogRowForm.oldPasword" type="password" auto-complete="new-password" autocomplete="false" clearable/>
            </el-form-item>
            <el-form-item label="新密码：" prop="newPassword">
                <el-input v-model="dialogRowForm.newPassword" type="password" auto-complete="new-password" autocomplete="false" clearable/>
            </el-form-item>
            <el-form-item label="确认密码：" prop="reNewPassword">
                <el-input v-model="dialogRowForm.reNewPassword" type="password" auto-complete="new-password" autocomplete="false" clearable/>
            </el-form-item>
            <el-form-item label-width="0px" class="btn-form-item-c" style="padding-top: 10px;text-align: center;">
				<el-button  type="primary" @click="submitForm()">{{dialogForm.submitButton}}</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>

</template>

/* JS */
<script>
    import ApiAccount from '@/request/api-account'
    import {checkEmpty,validFormat,checkFormat} from '@/global/global-valid'

    export default {
        /**
         * @Des 组件名
         * @Auth Zhangbin
         * @Date 16:37 2021/4/30
         */
        name: 'PasswordDialog',
        /**
         * @Des 数据定义
         * @Auth Zhangbin
         * @Date 16:37 2021/4/30
         */
        data() {
            return{
                /**
                 * @Des 弹窗表单
                 * @Auth Zhangbin
                 * @Date 16:37 2021/4/30
                 */
                dialogForm: {
                    isEdit: true,
                    title: "修改密码",
                    dialogFormVisible: false,
                    submitButton: '提交'
                },
                /**
                 * @Des 弹窗行值
                 * @Auth Zhangbin
                 * @Date 16:38 2021/4/30
                 */
                dialogRowForm: {
                    accountId: '',
                    userName: "",
                    oldPasword: "",
                    newPassword: "",
                    reNewPassword: ""
                },
                /**
                 * @Des 弹窗规则
                 * @Auth Zhangbin
                 * @Date 16:38 2021/4/30
                 */
                rules: {
                    oldPasword: [
                        { required: true, message: '请输入旧密码', trigger: 'blur' },
                        {
                        	validator: (rule, value, callback) => {
	                            if (!checkFormat(value, validFormat.password) && false) {
	                            	new callback(new Error("6-18位，可包含数字、字母、英文符号"));
	                            } else {
	                                callback()
	                            }
	                        },
	                        trigger: "blur"
                        }
                    ],
                    newPassword: [
                        { required: true, message: '请输入新密码', trigger: 'blur' },
                        {
                        	validator: (rule, value, callback) => {
	                            if (!checkFormat(value, validFormat.password) && false) {
	                            	new callback(new Error("6-18位，可包含数字、字母、英文符号"));
	                            } else {
	                                callback()
	                            }
	                        },
	                        trigger: "blur"
                        }
                    ],
                    reNewPassword: [
                        { required: true, message: '请再次输入新密码', trigger: 'blur' },
                        {
                        	validator: (rule, value, callback) => {
								if (!checkFormat(value, validFormat.password) && false) {
									new callback(new Error("6-18位，可包含数字、字母、英文符号"));
								} else if (this.dialogRowForm.reNewPassword != this.dialogRowForm.newPassword) {
	                            	new callback(new Error("确认密码与新密码不一致"));
	                            } else {
									callback()
								}
	                        },
	                        trigger: "blur"
                        }
                    ],
                }
            }
        },
        /**
         * @Des 方法定义
         * @Auth Zhangbin
         * @Date 16:38 2021/4/30
         */
        methods:{
            /**
             * @Des 弹窗打开
             * @Auth Zhangbin
             * @Date 16:38 2021/4/30
             */
            openDialog(isEdit, data, index){
                this.dialogForm.isEdit = isEdit;
                this.dialogForm.dialogFormVisible = true;
                if(isEdit && data){
                    this.dialogRowForm.userName = data.userName;
                    this.dialogRowForm.accountId = data.accountId;
                }
            },
            /**
             * @Des 弹窗关闭
             * @Auth Zhangbin
             * @Date 16:38 2021/4/30
             */
            handleDialogClose(){
                this.reset()
            },
            /**
             * @Des 重置方法
             * @Auth Zhangbin
             * @Date 16:39 2021/4/30
             */
            reset(){
                this.cleanData(this.dialogRowForm);
                this.cleanValidate('dialogRowForm');
            },
            /**
             * @Des 提交方法
             * @Auth Zhangbin
             * @Date 16:39 2021/4/30
             */
            submitForm(){
                this.$refs.dialogRowForm.validate(valid => {
                    if(!valid) return false;
                    this.$request.postJsonRequest(ApiAccount.updatePwdApi, {
                        accountId: this.dialogRowForm.accountId,
                        password: this.dialogRowForm.oldPasword,
                        newPassword: this.dialogRowForm.newPassword,
                    }).then(result => {
                        // console.log(result); return false;
                        if(result.code == 0){
                        	this.dialogForm.dialogFormVisible = false;
                            this.$message({
                                message: '密码修改成功！',
                                type: 'success',
                                showClose: true,
                                dangerouslyUseHTMLString: true,
                                onClose: (() => {
                                	// 移除cookie
									this.removeCookies();
									this.$router.replace({path: '/'}, ()=>{}, ()=>{});
                                })
                            });

                        }else{
                            this.$message({
                                message: result.msg,
                                type: 'error',
                                showClose: true,
                                dangerouslyUseHTMLString: true
                            });
                        }
                    }).catch(error => {
                        console.error('修改密码异常', ApiAccount.updatePwdApi, error);
                    })
                })
            },
            /**
             * @Des 清除验证
             * @Auth Zhangbin
             * @Date 16:39 2021/4/30
             */
            cleanValidate(formName){
                // 清除表单校验的提示
                if (this.$refs[formName]) {
                    // 延时执行
                    this.$nextTick(function () {
                        this.$refs[formName].clearValidate();
                    })
                };
            },
            /**
             * @Des 清理数据
             * @Auth Zhangbin
             * @Date 16:39 2021/4/30
             */
            cleanData(form){
                this.$nextTick(function () {
                    form.accountId = '';
                    form.account = '';
                    form.oldPasword = '';
                    form.newPassword = '';
                    form.reNewPassword = '';
                })
            },
            /**
             * @Des 移除cookie
             * @Auth Zhangbin
             * @Date 16:57 2021/4/30
             */
			removeCookies() {
				this.$cookies.remove("username");
                this.$cookies.remove("usernameSecret");
				this.$cookies.remove("passwordSecret");
			},
        }
    }
</script>

/* CSS */
<style lang="scss" scoped>
	
</style>



// WEBPACK FOOTER //
// src/components_pages/Account/PasswordDialog.vue